module.exports = __webpack_public_path__ + "static/media/nina-de-siete-trojes-min.41b9915f.png";